import { useMutation, useQueryClient } from '@tanstack/react-query';
import { registerPaymentMethod } from '@/services/subscription.service';
import { queryKeys } from '@/hooks/queries/keys';
import type { PaymentMethodDto, RegisterPaymentMethodReq } from '@/types/subscription';

export const useRegisterPaymentMethod = () => {
    const queryClient = useQueryClient();
    return useMutation<PaymentMethodDto, unknown, RegisterPaymentMethodReq>({
        mutationFn: registerPaymentMethod,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: queryKeys.subscription.paymentMethods() });
        },
    });
};
